import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-footer d-flex justify-content-between"
}
const _hoisted_2 = {
  key: 0,
  class: "list-pagination-prev pagination pagination-tabs card-pagination"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "list-pagination pagination pagination-tabs card-pagination" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "page" }
const _hoisted_7 = {
  key: 2,
  class: "list-pagination-next pagination pagination-tabs card-pagination"
}
const _hoisted_8 = { key: 3 }

import { PaginationLinks } from "@/@types";

type TablePaginationProps = {
  links: PaginationLinks[];
  hasPrevPage: boolean;
  hasNextPage: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'TablePagination',
  props: {
    links: { default: () => ([]) },
    hasPrevPage: { type: Boolean },
    hasNextPage: { type: Boolean }
  },
  emits: ["onPrev", "onNext", "onPageLink"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;



const onGoPrev = () => emits("onPrev");
const onGoNext = () => emits("onNext");
const onGoToPage = (page: string) => emits("onPageLink", page);

return (_ctx: any,_cache: any) => {
  return (_ctx.links.length > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.hasPrevPage)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              _createElementVNode("li", {
                class: "page-item cursor-pointer",
                onClick: onGoPrev
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "page-link ps-0 pe-4 border-end" }, [
                  _createElementVNode("i", { class: "fa-solid fa-chevron-left me-1" }),
                  _createTextVNode(" Anterior ")
                ], -1)
              ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3)),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
            return (_openBlock(), _createElementBlock("li", {
              onClick: ($event: any) => (onGoToPage(link.label)),
              class: _normalizeClass([{ active: link.active }, "cursor-pointer"]),
              key: index
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(link.label), 1)
            ], 10, _hoisted_5))
          }), 128))
        ]),
        (_ctx.hasNextPage)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
              _createElementVNode("li", {
                class: "page-item cursor-pointer",
                onClick: onGoNext
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("span", { class: "page-link ps-4 pe-0 border-start" }, [
                  _createTextVNode(" Próxima "),
                  _createElementVNode("i", { class: "fa-solid fa-chevron-right ms-1" })
                ], -1)
              ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8))
      ]))
    : _createCommentVNode("", true)
}
}

})